import { Plus, Minus, RotateCcw } from "lucide-react";

/**
 * Compact +/-/reset controls for the map components. Positioned by parent.
 */
export default function MapZoomControls({ zoom, min = 1, max = 6, onZoomIn, onZoomOut, onReset, testIdPrefix = "map-zoom" }) {
  return (
    <div
      data-testid={`${testIdPrefix}-controls`}
      className="absolute top-3 right-3 bg-white border border-[var(--ink)] flex flex-col divide-y divide-[var(--line)] z-10"
    >
      <button
        data-testid={`${testIdPrefix}-in`}
        onClick={onZoomIn}
        disabled={zoom >= max}
        aria-label="Zoom in"
        className="w-9 h-9 flex items-center justify-center hover:bg-[var(--paper-2)] disabled:opacity-40 disabled:cursor-not-allowed"
      >
        <Plus className="w-4 h-4" />
      </button>
      <button
        data-testid={`${testIdPrefix}-out`}
        onClick={onZoomOut}
        disabled={zoom <= min}
        aria-label="Zoom out"
        className="w-9 h-9 flex items-center justify-center hover:bg-[var(--paper-2)] disabled:opacity-40 disabled:cursor-not-allowed"
      >
        <Minus className="w-4 h-4" />
      </button>
      <button
        data-testid={`${testIdPrefix}-reset`}
        onClick={onReset}
        disabled={zoom === 1}
        aria-label="Reset zoom"
        className="w-9 h-9 flex items-center justify-center hover:bg-[var(--paper-2)] disabled:opacity-40 disabled:cursor-not-allowed"
      >
        <RotateCcw className="w-3.5 h-3.5" />
      </button>
      <div className="px-1 py-0.5 font-label text-[9px] text-center text-[var(--ink-soft)] bg-[var(--paper-2)]">
        {zoom.toFixed(1)}x
      </div>
    </div>
  );
}
